// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1CDRO","question":"Question_question__3KliG","description":"Question_description__1FkvU"};